import React from 'react';

function ImportantIcon(props: React.ComponentProps<'div'>) {
    return (
        <div {...props}>
            <svg
                style={{ width: 'inherit' }}
                id="e3kuCDMncNi1"
                xmlns="http://www.w3.org/2000/svg"
                width="135"
                height="121"
                shapeRendering="geometricPrecision"
                textRendering="geometricPrecision"
            >
                <path
                    id="e3kuCDMncNi2"
                    d="M61.5,3.2C64,-1.1,70.2,-1.1,72.7,3.2L133.3,108.4C135.8,112.7,132.7,118.1,127.7,118.1L6.5,118.1C1.5,118.1,-1.6,112.7,0.9,108.4L61.5,3.2Z"
                    fill="rgb(255,212,60)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi3"
                    d="M32.4,117.3C32.4,117.3,33.1,118.2,36.5,119C37.2,119.2,38,119.3,38,120.4C36.4,120.4,34.7,120.4,34.7,120.4L31.3,119.9L31.3,120.4L29.5,120.4C29.5,120.4,29,117.7,30.1,117.4C31.1,117.3,32.4,117.3,32.4,117.3Z"
                    fill="rgb(26,58,85)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi4"
                    d="M32.6,115.4L32.4,117.3C31.7,117.7,30.9,117.7,30.2,117.4L30.1,117.3L30.1,115.4L32.6,115.4Z"
                    fill="rgb(255,255,255)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi5"
                    d="M15.4,117.7C15.4,117.7,16.1,118.6,19.5,119.4C20.2,119.6,21,119.7,21,120.8C19.4,120.8,17.7,120.8,17.7,120.8L14.3,120.3L14.3,120.8L12.5,120.8C12.5,120.8,12,118.1,13.1,117.8C14,117.7,15.4,117.7,15.4,117.7Z"
                    fill="rgb(26,58,85)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi6"
                    d="M15.6,115.8L15.4,117.7C14.7,118.1,13.8,118.1,13.2,117.8L13.1,117.7L13.1,115.8L15.6,115.8Z"
                    fill="rgb(255,255,255)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi7"
                    d="M34,67.6L33.2,116.4L29.3,116.4C29.3,116.4,23.3,77,24.6,67.6C25.7,58.2,34,67.6,34,67.6Z"
                    fill="rgb(71,71,104)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi8"
                    d="M29.8,67.6C29.8,67.6,28.4,82.6,25.3,90.9C22.1,99.2,16.4,116.4,16.4,116.4L12.3,116.4C12.3,116.4,19.1,80.4,17.6,67.6L29.8,67.6Z"
                    fill="rgb(90,90,124)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi9"
                    d="M33.3,42.8C33.3,42.8,38.2,53,39.4,53C40.4,53,39,44.7,39,44.7L43.1,44.7C43.1,44.7,48.2,59,44.2,61.6C40.1,64.2,31.2,54.2,31.2,54.2L33.3,42.8Z"
                    fill="rgb(46,99,255)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi10"
                    d="M18.8,68.9L20.3,72.2C21,73.5,23.6,73.5,25.3,73.1C25.6,73,25.7,72.8,25.5,72.6C24.5,71.7,22.1,69.3,21.2,68.7L18.8,68.9Z"
                    fill="rgb(255,239,233)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi11"
                    d="M29.3,40.6C30.9,40.6,32.4,41.3,33.2,42.6C33.5,43,33.7,43.5,33.7,44C33.7,45.8,33.7,67.6,33.7,67.6L18.8,67.6L18.8,45.5C18.8,45.5,19.1,40.6,24.4,40.6C26.7,40.6,28.3,40.6,29.3,40.6Z"
                    fill="rgb(46,99,255)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi12"
                    d="M42.4,44.6L42.3,43.9C42,42.3,40.3,40.4,38.7,39.9L37,39.9L37.5,43.2L39.9,44.6L42.4,44.6Z"
                    fill="rgb(255,239,233)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi13"
                    d="M38.1,42.9L41.5,44.7C41.5,44.7,39.4,44.7,39.4,44.7L35.8,42C35.8,42,36.1,41.5,36.9,41.9C37.6,42.3,38.1,42.9,38.1,42.9Z"
                    fill="rgb(255,239,233)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi14"
                    d="M20.4,42.1C20.4,42.1,12,50.5,12,55.6C12,60.7,18.8,69.5,18.8,69.5L22.2,68.6C22.2,68.6,19.2,57.6,19.2,54.7C19.2,51.8,25.5,47.5,25.5,47.5"
                    fill="rgb(46,99,255)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi15"
                    d="M35.9,37.9C35.9,37.9,35.7,41.2,38.2,43.6C38.4,43.7,38.6,43.8,38.9,43.8C39.4,43.8,39.8,43.6,40,43.5C40.4,43.4,40.6,43.1,40.6,43C40.7,42.9,40.6,42.7,40.5,42.6C40,42.1,38.3,40.1,38.7,38.2C37.4,37.4,35.9,37.9,35.9,37.9Z"
                    fill="rgb(46,99,255)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi16"
                    d="M40.3,43.3C40.5,43.2,40.6,43.1,40.6,42.9C40.7,42.8,40.6,42.6,40.5,42.5C40,42,38.3,40,38.7,38.1C38.2,37.8,37.7,37.7,37.3,37.7C37.6,39.7,38.2,41,40.3,43.3Z"
                    fill="rgb(46,99,255)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi17"
                    d="M18.2,55L21.7,67C21,64.7,20.1,58.3,19.7,55.5C19.3,52.7,20.7,51,21.7,50L22.2,48C20.6,48.4,18.1,53,18.2,55Z"
                    fill="rgb(47,83,188)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi18"
                    d="M38.3,40.3C38.5,40.8,38.8,41.1,39,41C39.2,40.9,39.2,40.5,39,40.1C38.8,39.6,38.5,39.3,38.3,39.4C38.1,39.4,38.1,39.8,38.3,40.3Z"
                    fill="rgb(46,99,255)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi19"
                    d="M38.3,39.4L38.5,39.3L38.5,39.4L38.3,39.4L38.3,39.4Z"
                    fill="rgb(26,58,85)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi20"
                    d="M38.9,41L39.1,40.9L38.9,41L38.9,41Z"
                    fill="rgb(230,235,252)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi21"
                    d="M38.4,40.2C38.6,40.7,38.9,41,39.1,40.9C39.3,40.8,39.3,40.4,39.1,40C38.9,39.5,38.6,39.2,38.4,39.3C38.3,39.4,38.3,39.8,38.4,40.2Z"
                    fill="rgb(46,99,255)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi22"
                    d="M34.6,35.2L34.2,35.2C33.4,35.3,32.9,35.9,33,36.5L33.1,37.4C33.2,38,33.9,38.5,34.6,38.4L35,38.4L34.6,35.2Z"
                    fill="rgb(46,99,255)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi23"
                    d="M46.9,34.8C47.3,37.4,46.9,39.5,46.1,39.6C45.3,39.7,44.3,37.7,44,35.1C43.6,32.5,44,30.4,44.8,30.3C45.6,30.2,46.5,32.2,46.9,34.8Z"
                    fill="rgb(26,58,85)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi24"
                    d="M43.6,33.4L44.8,33.9L45,35.4L44,36.6L43.3,34.7L43.6,33.4Z"
                    fill="rgb(255,255,255)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi25"
                    d="M43.9,35.1C43.6,32.9,43.8,31.1,44.4,30.5C40,34.2,34.4,35.3,34.4,35.3L34.9,38.6C34.9,38.6,42.5,37.3,45.7,39.5C45.7,39.5,45.7,39.5,45.7,39.5C44.9,39,44.2,37.3,43.9,35.1Z"
                    fill="rgb(255,232,60)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi26"
                    d="M45.1,34.7C45.2,35.1,45.1,35.5,45.1,35.5C45,35.5,44.9,35.2,44.8,34.8C44.7,34.4,44.8,34,44.8,34C45,33.9,45.1,34.3,45.1,34.7Z"
                    fill="rgb(235,242,83)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi27"
                    d="M40.5,42.2C40.4,42.2,40,42.5,38.6,42.5C37.6,42.5,37.2,41.4,37,40.8C36.9,40.6,36.9,40.3,37.2,40.2L38.8,40L40.5,42.2Z"
                    fill="rgb(255,239,233)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi28"
                    d="M69.6,83.3L62.7,83.3L62.2,40.3L70.2,40.3L69.6,83.3ZM61.9,96.3C61.9,95.1,62.3,94,63,93.2C63.8,92.4,64.9,91.9,66.4,91.9C67.9,91.9,69,92.3,69.8,93.2C70.6,94,71,95,71,96.3C71,97.6,70.6,98.6,69.8,99.4C69,100.2,67.9,100.6,66.4,100.6C64.9,100.6,63.8,100.2,63,99.4C62.3,98.6,61.9,97.6,61.9,96.3Z"
                    fill="rgb(0,56,255)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi29"
                    d="M25.8,42.2L26.5,42.2C27.4,42.2,28.2,41.5,28.2,40.5L28.2,34.6C28.2,33.7,27.5,32.9,26.5,32.9L25.8,32.9C24.9,32.9,24.1,33.6,24.1,34.6L24.1,40.5C24.1,41.4,24.8,42.2,25.8,42.2Z"
                    fill="rgb(247,222,213)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi30"
                    d="M27,38L27.5,38C29.2,38,30.6,36.6,30.6,34.9L30.6,30.5C30.6,28.8,29.2,27.4,27.5,27.4L27,27.4C25.3,27.4,23.9,28.8,23.9,30.5L23.9,34.9C23.9,36.6,25.3,38,27,38Z"
                    fill="rgb(255,239,233)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi31"
                    d="M22.8,29.4C22.9,27.8,24.1,27.3,25.1,27.3L28.3,27.3C28.3,27.3,30.8,27.4,31,29.3C31.2,30.7,28.3,31.7,26.8,32.1C26.6,32.1,26.5,33.1,26.4,33.1C26.1,33.2,25.9,32.3,25.9,32.3C25.9,32.3,25.4,31.4,24.8,31.5C24.6,31.5,24.2,32,24.3,32.8C24.4,33.6,25.1,34,25.1,34C25.1,34,25,35.5,23.7,34.7C23.3,34.5,22.9,33.7,23,32.4C23.1,31.7,22.8,31.6,22.8,30.9L22.8,29.4L22.8,29.4Z"
                    fill="rgb(35,31,32)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi32"
                    d="M29.4,32.9C29.4,32.8,29.4,32.8,29.4,32.7C29.4,32.6,29.1,32.6,29.1,32.7C29,33.1,29.1,33.5,29.4,33.9C29.5,34,29.5,34.1,29.6,34.1C29.6,34.1,29.6,34.1,29.6,34.2C29.6,34.2,29.6,34.3,29.5,34.3C29.4,34.5,29.2,34.6,29.1,34.6C28.9,34.7,29,34.9,29.2,34.9C29.4,34.8,29.6,34.7,29.7,34.6C29.8,34.4,30,34.2,29.8,34C29.7,33.9,29.7,33.9,29.6,33.8C29.5,33.7,29.5,33.6,29.5,33.5C29.4,33.3,29.4,33.1,29.4,32.9C29.3,32.8,29.2,32.8,29.1,32.8C29.1,32.8,29.1,32.9,29.1,33C29.2,33.2,29.5,33.1,29.4,32.9Z"
                    fill="rgb(228,192,178)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi33"
                    d="M27.7,36.2C28.2,36.5,28.9,36.5,29.5,36.2C29.7,36.1,29.5,35.8,29.4,35.9C29,36.2,28.4,36.2,27.9,36C27.7,35.8,27.5,36.1,27.7,36.2Z"
                    fill="rgb(228,192,178)"
                    stroke="none"
                    strokeWidth="1"
                />
                <path
                    id="e3kuCDMncNi34"
                    d="M25.4,32.5C25.3,32.4,25.2,32.3,25,32.2C24.9,32.2,24.9,32.2,24.8,32.3C24.7,32.5,24.7,32.7,24.8,32.9C24.9,33.1,25.1,33.2,25.3,33.2C25.3,33.2,25.4,33.2,25.4,33.2C25.4,33.2,25.5,33.1,25.5,33.1C25.5,33,25.5,32.9,25.4,32.9C25.4,32.9,25.4,32.9,25.3,32.9C25.3,32.9,25.3,32.9,25.3,32.9C25.3,32.9,25.3,32.9,25.3,32.9C25.3,32.9,25.3,32.9,25.3,32.9C25.3,32.9,25.3,32.9,25.3,32.9C25.3,32.9,25.3,32.9,25.3,32.9C25.3,32.9,25.3,32.9,25.3,32.9C25.3,32.9,25.3,32.9,25.3,32.9C25.3,32.9,25.3,32.9,25.3,32.9C25.3,32.9,25.3,32.9,25.3,32.9C25.3,32.9,25.3,32.9,25.3,32.9C25.3,32.9,25.3,32.9,25.3,32.9C25.3,32.9,25.3,32.9,25.3,32.9C25.3,32.9,25.3,32.9,25.3,32.9C25.3,32.9,25.3,32.9,25.3,32.9C25.3,32.9,25.3,32.9,25.3,32.8C25.3,32.8,25.3,32.8,25.3,32.8C25.3,32.8,25.3,32.8,25.3,32.8C25.3,32.8,25.3,32.8,25.3,32.7C25.3,32.7,25.3,32.7,25.3,32.7C25.3,32.7,25.3,32.7,25.3,32.7C25.3,32.7,25.3,32.7,25.3,32.7C25.3,32.7,25.3,32.7,25.3,32.7C25.3,32.7,25.3,32.7,25.3,32.7C25.3,32.7,25.3,32.7,25.3,32.7C25.2,32.7,25.2,32.7,25.1,32.8C25.1,32.8,25.1,32.8,25.1,32.8C25.1,32.8,25.1,32.8,25.1,32.8C25.1,32.8,25.1,32.8,25.1,32.8C25.1,32.8,25.1,32.8,25.1,32.8C25.1,32.8,25.1,32.8,25.1,32.8C25.1,32.8,25.1,32.8,25.1,32.8C25.1,32.8,25.1,32.8,25.2,32.9C25.2,32.9,25.2,32.9,25.2,32.9C25.2,32.9,25.2,32.9,25.2,32.9C25.2,32.9,25.2,32.9,25.2,32.9C25.2,33,25.3,33,25.4,33C25.4,32.6,25.4,32.6,25.4,32.5Z"
                    fill="rgb(40,57,74)"
                    stroke="none"
                    strokeWidth="1"
                />
            </svg>
        </div>
    );
}

export default ImportantIcon;
